import React from 'react';
import PropTypes from 'prop-types';
import {IconButton, Paper, Subheader} from 'material-ui';
import style from '../../styles/styles';
import styles from './NewsInfo.css';
import Info from "../common/Info/Info";
import {white} from "material-ui/styles/colors";
import ActionFavorite from 'material-ui/svg-icons/action/favorite';
import withTranslation from "../../hoc/withTranslation";
import { ActionVisibility, ActionVisibilityOff } from 'material-ui/svg-icons';
import { RICHTEXT } from '../../constants/customfiled';

const Timestamp = require('react-timestamp');

class NewsInfo extends React.Component {
    static propTypes = {
        news: PropTypes.object.isRequired
    };

    render() {
        const news = this.props.news;
        return (
            <Paper>
                <Subheader style={{...style.subHeader, ...style.relative}}>
                    {this.props.t('generic.information')}
                    {news.is_favorite &&
                    <IconButton
                        style={styles.rightIcon}
                        tooltip={this.props.t('module.news.favorite_news')}
                        tooltipPosition='bottom-left'
                    >
                        <ActionFavorite color={white}/>
                    </IconButton>
                    }
                    {news.visible &&
                    <IconButton
                        style={styles.rightVisibleIcon}
                        tooltip={this.props.t('module.news.visible_news')}
                        tooltipPosition='bottom-left'
                    >
                        <ActionVisibility color={white}/>
                    </IconButton>
                    }
                    {!news.visible &&
                    <IconButton
                        style={styles.rightVisibleIcon}
                        tooltip={this.props.t('module.news.not_visible_news')}
                        tooltipPosition='bottom-left'
                    >
                        <ActionVisibilityOff color={white}/>
                    </IconButton>
                    }
                </Subheader>

                <div style={style.paper}>
                    <Info
                        title={this.props.t('generic.identifier')}
                        content={news.id}
                    />
                    {news.title &&
                    <Info
                        title={this.props.t('generic.title')}
                        content={news.title}
                    />
                    }
                    {news.excerpt &&
                    <Info
                        title={this.props.t('generic.excerpt')}
                        content={news.excerpt}
                        html={true}
                    />
                    }
                    {news.content &&
                        <Info
                            title={this.props.t('generic.content')}
                            content={news.content}
                            html={true}
                        />
                    }
                    {news.tag &&
                    <Info
                        title={this.props.t('generic.tag')}
                        content={news.tag}
                    />
                    }
                    {news.custom_fields &&
                    news.custom_fields.filter(cf => cf.value != null).map((cf) => {
                        let customField = this.props.customFields.find(item => item.id === cf.id);
                        let name = cf.id;

                        if (customField) {
                            name = customField.name
                        }

                        if (cf.tag && cf.tag.length > 0) {
                            name += ' (' + cf.tag + ')'
                        }

                        return (
                            <Info
                                key={cf.id}
                                title={name}
                                content={cf.value}
                                html={customField.type === RICHTEXT}
                            />
                        );

                    })}
                    <Info
                        title={this.props.t('generic.created_at')}
                        content={<Timestamp time={this.props.news.created_at} format='full' twentyFourHour/>}
                    />
                    <Info
                        title={this.props.t('generic.updated_at')}
                        content={(
                            this.props.news.updated_at &&
                            <Timestamp time={this.props.news.updated_at} format='full' twentyFourHour/>
                        ) ||  this.props.t('generic.updated_never')}
                        divider={false}
                    />
                </div>
            </Paper>
        );
    }
}

export default withTranslation(NewsInfo);



// WEBPACK FOOTER //
// src/components/news/NewsInfo.js